export default __webpack_public_path__ + "media/images/icons_fc/dossierblanc-b79c24bef58524fc565e53d670e7b124.png";